module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "phone-input-wrapper"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.required),
      expression: "required"
    }],
    staticClass: "required-indicator"
  }, [_vm._v("*")]), _vm._v(" "), (_vm.required && _vm.showError) ? _c('span', {
    staticClass: "icon-input-error"
  }) : _vm._e(), _vm._v(" "), _c('vue-phone-number-input', {
    class: {
      'filled': _vm.hasValue,
      'error': _vm.required && _vm.showError
    },
    attrs: {
      "value": _vm.value,
      "default-country-code": _vm.defaultCountryCode
    },
    on: {
      "update": function (val) { return _vm.$emit('update', val); },
      "input": function (val) { return _vm.$emit('input', val); },
      "phone-number-focused": function () { return _vm.$emit('focus'); }
    }
  }), _vm._v(" "), (_vm.required && _vm.showError) ? _c('label', {
    staticClass: "error-text"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-5dd9be22!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/v-components/vPhoneInput.vue
// module id = 1554
// module chunks = 18 19 22